import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { advertisers } from "../api/advertisers";
import { ApiError } from "../api/client";

export function AdvertisersPage() {
  const queryClient = useQueryClient();
  const [displayName, setDisplayName] = useState("");
  const [legalName, setLegalName] = useState("");
  const [formError, setFormError] = useState<string | null>(null);

  const list = useQuery({ queryKey: ["advertisers"], queryFn: advertisers.list });

  const create = useMutation({
    mutationFn: advertisers.create,
    onSuccess: async () => {
      setDisplayName("");
      setLegalName("");
      setFormError(null);
      // Refetch the list so the new row is real data, not an optimistic guess.
      await queryClient.invalidateQueries({ queryKey: ["advertisers"] });
    },
    onError: (error) => {
      setFormError(error instanceof ApiError ? `Не сохранено: ${error.code}` : "Не сохранено");
    },
  });

  function submit(event: FormEvent) {
    event.preventDefault();
    const display = displayName.trim();
    const legal = legalName.trim();
    if (!display || !legal) return;
    create.mutate({ displayName: display, legalName: legal, legalMetadata: "{}" });
  }

  return (
    <>
      <h2>Рекламодатели</h2>

      <form className="toolbar" onSubmit={submit}>
        <input
          placeholder="Отображаемое название"
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
          style={{ maxWidth: 320 }}
        />
        <input
          placeholder="Юридическое название"
          value={legalName}
          onChange={(e) => setLegalName(e.target.value)}
          style={{ maxWidth: 320 }}
        />
        <button className="primary" type="submit" disabled={create.isPending || !displayName.trim() || !legalName.trim()}>
          {create.isPending ? "Сохраняю…" : "Создать"}
        </button>
      </form>
      {formError && <p className="error">{formError}</p>}

      <div className="panel">
        {list.isLoading && <p className="muted">Загружаю…</p>}
        {list.isError && <p className="error">Не удалось загрузить список.</p>}
        {list.data && list.data.length === 0 && <p className="muted">Пока ни одного рекламодателя.</p>}
        {list.data && list.data.length > 0 && (
          <table>
            <thead>
              <tr>
                <th>Название</th>
                <th>Статус</th>
                <th>Версия</th>
                <th>Создан</th>
              </tr>
            </thead>
            <tbody>
              {list.data.map((a) => (
                <tr key={a.id}>
                  <td>
                    <Link to={`/advertisers/${a.id}`}>{a.displayName}</Link>
                  </td>
                  <td>{a.status}</td>
                  <td>{a.version}</td>
                  <td>{new Date(a.createdAt).toLocaleString("ru-RU")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}
